import Client from "./base/client";

export class Auth {
  private client: Client;

  private host = window.location.origin;

  constructor(client: Client) {
    this.client = client;
  }

  private resourceUrl = "/api/v1/auth";

  login = <TData extends object>({
    email,
    password,
  }: {
    email: string;
    password: string;
  }): Promise<TData> => {
    const params = new URLSearchParams({ email, password, action: "login" });
    return this.client.post(`${this.host}/ajax.php`, params);
  };

  getUserInfo = <TData extends object>(): Promise<TData> => {
    const params = new URLSearchParams({ action: "login" });
    return this.client.post(`${this.host}/ajax.php`, params);
  };

  forgotPassword = ({ email }: { email: string }): Promise<unknown> => {
    const params = new URLSearchParams({ email, action: "forgot_password" });
    return this.client.post(`${this.host}/ajax.php`, params);
  };

  logout = () => this.client.post(`${this.resourceUrl}/logout`);
}
